import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

const CHECKBOX_INPUT_CONTROL_VALUE_ACCESSOR = {
  multi: true,
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CheckboxComponent),
};

const noop = (): void => {};

@Component({
  selector: 'tmw-checkbox',
  standalone: true,
  styleUrl: './checkbox-input.component.css',
  templateUrl: './checkbox-input.component.html',
  imports: [FormsModule],
  providers: [CHECKBOX_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class CheckboxComponent implements ControlValueAccessor {
  state: boolean | null = null;

  isDisabled = false;
  private onChange = (_: boolean | null) => {};
  private onTouched = noop;

  writeValue(value: boolean | null): void {
    this.state = value??null;
    if(this.state != null) {
      this.state = !!this.state;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  toggleState(): void {
    if (this.isDisabled) {
      return;
    }

    if (this.state === null) {
      this.state = true;
    } else if (this.state === true) {
      this.state = false;
    } else {
      this.state = null;
    }

    this.onChange(this.state);
    this.onTouched();
  }
}
